export default '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable]';


// WEBPACK FOOTER //
// ./js/utilities/focusable-elements/u-focusable-elements.js